module.exports = __webpack_public_path__ + "assets/img/top-arrow.578440b0.svg";